import { useState } from "react";
import { GalleryThemeContext, ThemeMode } from "./galleryKit";
import { FoundationsSection } from "./sections/foundations";
import { ControlsSection } from "./sections/controls";
import { ListsSection } from "./sections/lists";
import { SurfacesSection } from "./sections/surfaces";
import { ContentSection, FeedbackSection, NavigationSection, PublicSection } from "./sections/pages";
import { ChatSection } from "./sections/chat";
import { AreaSection } from "./sections/areas";

const SECTIONS = [
    { id: "foundations", label: "Foundations" },
    { id: "controls", label: "Controls" },
    { id: "lists", label: "Lists" },
    { id: "surfaces", label: "Containers" },
    { id: "navigation", label: "Navigation" },
    { id: "feedback", label: "Feedback" },
    { id: "content", label: "Content" },
    { id: "public", label: "Public" },
    { id: "chat", label: "Chat" },
    { id: "areas", label: "Feature areas" },
];

const MODES: ThemeMode[] = ["both", "light", "dark"];

/**
 * Living design guide: every component class in src/styles, shown in context-free form in
 * both themes. New components should be added here alongside their class.
 */
export const GalleryPage = () => {
    const [mode, setMode] = useState<ThemeMode>("both");

    return (
        <div className="scroll-box">
            <div className="gallery">
                <div className="gallery-intro">
                    <p className="eyebrow">Design system</p>
                    <p className="h2">Component gallery</p>
                    <p className="b text-black/70">
                        Every visual component in the app has one class (plus modifiers) defined in <code className="code-chip">src/styles</code>.
                        This page shows each of them on placeholder content, in both themes, with the rules for using it.
                        Build new components from these pieces; if something new is needed, add its class and a specimen here.
                    </p>
                </div>

                <div className="gallery-toolbar">
                    <div className="tabs">
                        {SECTIONS.map((s) => (
                            <button key={s.id} className="tab" onClick={() => document.getElementById(s.id)?.scrollIntoView({ behavior: "smooth" })}>
                                {s.label}
                            </button>
                        ))}
                    </div>
                    <div className="tabs">
                        {MODES.map((m) => (
                            <button key={m} className={`tab ${mode === m ? "tab-active" : ""}`} onClick={() => setMode(m)}>{m}</button>
                        ))}
                    </div>
                </div>

                <GalleryThemeContext.Provider value={mode}>
                    <FoundationsSection />
                    <ControlsSection />
                    <ListsSection />
                    <SurfacesSection />
                    <NavigationSection />
                    <FeedbackSection />
                    <ContentSection />
                    <PublicSection />
                    <ChatSection />
                    <AreaSection />
                </GalleryThemeContext.Provider>
            </div>
        </div>
    );
};
